import React from 'react';

import { flagStyles } from '../settings';

const SvgDM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1392px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDM;
